export default __webpack_public_path__ + "media/sm_opportunity4_icon.099074fc5caa04d28976f4bf42e0acc1.svg";